import { useTranslation } from "react-i18next";
import { Cpu, Users, LayoutDashboard, Server, DollarSign } from "lucide-react";
import { FAQItem } from "./FAQItem";
import { HostingHighlight } from "./HostingHighlight";

export default function FAQ() {
    const { t } = useTranslation();

    return (
        <div className="mt-16 mb-12">
            <div className="text-center mb-10">
                <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-3">
                    {t("billing.faq.title")}
                </h2>
                <p className="text-slate-500 text-lg max-w-lg mx-auto">
                    {t("billing.faq.subtitle")}
                </p>
            </div>

            <div className="max-w-3xl mx-auto space-y-6">
                <HostingHighlight t={t} />

                <div className="space-y-3">
                    <FAQItem question={t("billing.faq.hostingIncluded.question")} icon={Server} defaultOpen>
                        <p>{t("billing.faq.hostingIncluded.answer")}</p>
                    </FAQItem>
                    <FAQItem question={t("billing.faq.whatIsCredit.question")} icon={Cpu}>
                        <p>{t("billing.faq.whatIsCredit.answer1")}</p>
                        <p>{t("billing.faq.whatIsCredit.answer2")}</p>
                    </FAQItem>
                    <FAQItem question={t("billing.faq.internalVsExternal.question")} icon={Users}>
                        <p>{t("billing.faq.internalVsExternal.answer1")}</p>
                        <p>{t("billing.faq.internalVsExternal.answer2")}</p>
                    </FAQItem>
                    <FAQItem question={t("billing.faq.internalPortal.question")} icon={LayoutDashboard}>
                        <p>{t("billing.faq.internalPortal.answer")}</p>
                    </FAQItem>
                    <FAQItem question={t("billing.faq.currency.question")} icon={DollarSign}>
                        <p>{t("billing.faq.currency.answer")}</p>
                    </FAQItem>
                </div>
            </div>
        </div>
    );
}
